import React from "react";
import { ModalType, useModalStore } from "store/useModalStore";
import LoadingModal from "./LoadingModal";
import { LoadingModalProps } from "types/modal";
import GroupStudyChallengeModal from "./GroupStudyChallengeModal";
import NewMobileAppGuideModal from "./NewMobileAppGuideModal";
import IPadAppTerminationModal from "./IPadAppTerminationModal";
import MobileAppInstallModal from "./MobileAppInstallModal";
import ServiceNotificationModal from "./ServiceNotificationModal";
import DesktopGuideToRestart from "./DesktopGuideToRestart";
import ImageFullScreenModal from "./ImageFullScreenModal";
import ScaleFactorChangeModal from "./ScaleFactorChangeModal";
import SelectWindowModal from "./SelectWindowModal";

const ModalSwitcher = () => {
  const { modalState } = useModalStore();
  if (modalState.display) {
    switch (modalState.type) {
      case ModalType.LOADING:
        const loadingModalState = modalState as LoadingModalProps;
        return <LoadingModal text={loadingModalState.text} closable={false} target={loadingModalState.target} display={true} type={ModalType.LOADING} />;
      case ModalType.STUDY_CHALLENGE:
        return <GroupStudyChallengeModal closable={true} type="study_challenge" />;
      case ModalType.NEW_MOBILE_APP_GUIDE:
        return <NewMobileAppGuideModal />;
      case ModalType.IPAD_APP_TERMINATION:
        return <IPadAppTerminationModal />;
      case ModalType.MOBILE_APP_INSTALL:
        return <MobileAppInstallModal />;
      case ModalType.SERVICE_NOTIFICATION:
        return <ServiceNotificationModal />;
      case ModalType.DESKTOP_GUIDE_TO_RESTART:
        return <DesktopGuideToRestart />;
      case ModalType.IMAGE_FULL_SCREEN:
        return <ImageFullScreenModal />;
      case ModalType.DESKTOP_SCALE_FACTOR_CHANGE:
        return <ScaleFactorChangeModal />;
      case ModalType.DESKTOP_SELECT_WINDOW:
        return <SelectWindowModal />;
      default:
        return <></>;
    }
  }
  return <></>;
};

export default ModalSwitcher;
